import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { api } from '../services/api';
import { getRole } from './roles';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accessDenied, setAccessDenied] = useState(false);

  const BACKEND_LOGIN_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/auth/login`;
  const BACKEND_LOGOUT_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/auth/logout`;

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    setLoading(true);
    setAccessDenied(false);
    try {
      const userData = await api.getCurrentUser();
      setUser(userData);
    } catch (error) {
      console.error('Error fetching user info:', error);
      setUser(null);
      if (error.code === 'ACCESS_DENIED') {
        setAccessDenied(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const role = useMemo(() => getRole(user), [user]);

  const login = () => {
    window.location.href = BACKEND_LOGIN_URL;
  };

  const logout = () => {
    setAccessDenied(false);
    setTimeout(() => {
      window.location.href = BACKEND_LOGOUT_URL;
    }, 0);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, fetchUserInfo, role, accessDenied }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 